export default __webpack_public_path__ + "static/media/pig-yellow.ee89f031.svg";